/**
 * Route for `advertiser-approval`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserApprovalPage } from "../features/advertiser-approval/AdvertiserApprovalPage";

export const advertiserApprovalRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-approval",
	component: AdvertiserApprovalPage,
});

export default advertiserApprovalRoute;
